export default "__VITE_ASSET__DNIrPn63__"